<template>
  <div
    class="pos-final-ticket-container pos-fnb-final-ticket-wrapper pos-final-ticket-wrapper"
  >
    <div class="">
      <button class="btn-modal-close" @click="callClose()">&times;</button>
      <div class="h4 font-weight-bold text-center">PICK UP TICKET</div>
      <div class="position-relative h-600 d-flex align-items-center">
        <div class="col-10 mx-auto">
          <div class="row">
            <div class="col-4">
              <div class="pos-mobile-number" v-if="false">
                <form>
                  <div class="row">
                    <span>{{
                      phoneError && phoneError.length > 0 ? phoneError : ""
                    }}</span>
                    <div class="col-12 mb-4">
                      <input
                        v-model="phonenumber"
                        @change="inputChange($event)"
                        type="text"
                        placeholder="Mobile Number"
                      />
                    </div>
                    <div class="col-11 mx-auto">
                      <div class="row">
                        <div
                          class="col-4 mb-2"
                          v-for="(value, index) in phone_value"
                          :key="index"
                        >
                          <button
                            v-if="index == phone_value.length - 1"
                            @click.prevent.stop="onSliceNUmber()"
                            class="number"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else-if="value.name != ''"
                            @click.prevent.stop="onClickNumber(value.name)"
                            class="number"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else
                            @click.prevent.stop="clearPhoneNumber"
                            class="number"
                          >
                            C
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div
                class="pos-mobile-number"
                :class="!showSendSmsSection ? 'disbled-section' : ''"
              >
                <form>
                  <div class="row">
                    <span>{{
                      phoneError && phoneError.length > 0 ? phoneError : ""
                    }}</span>
                    <div class="col-4 mb-4 pr-3">
                      <!--variant="dropdown-curve bg-theme-light"-->
                      <!--:text="getCustMobCode"-->
                      <b-dropdown
                        variant="dropdown-curve"
                        class="w-100 text-center mr-3"
                        :disabled="!showSendSmsSection"
                        :text="getCustMobCode ? getCustMobCode : 'Code'"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Code"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                            class="form-control form-control-sm"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in Countries"
                          :key="countryIndex"
                          v-on:click="
                            onSelectHandler('countrycode', countrycode)
                          "
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div class="col-8 mb-4 pl-0">
                      <input
                        v-model="input_number"
                        type="text"
                        :disabled="!showSendSmsSection"
                        placeholder="Mobile Number"
                        class="mobile-number"
                        v-on:keydown="
                          (e) => {
                            if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                              e.preventDefault();
                            }
                          }
                        "
                      />
                    </div>
                    <div class="col-11 mx-auto">
                      <div class="row">
                        <div
                          class="col-4 mb-2"
                          v-for="(value, index) in phone_value"
                          :key="index"
                        >
                          <button
                            v-if="index == phone_value.length - 1"
                            @click.prevent.stop="onSliceNUmber()"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else-if="value.name != ''"
                            @click.prevent.stop="onClickNumber(index)"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            {{ value.name }}
                          </button>
                          <button
                            v-else
                            @click.prevent.stop="clearPhoneNumber"
                            class="number"
                            :disabled="!showSendSmsSection"
                          >
                            C
                          </button>
                        </div>
                        <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                          <button
                            @click.prevent.stop="onClickNumber(mobile)"
                            v-if="mobile < 11"
                          >{{ mobile }}</button>
                          <button v-else @click.prevent.stop="clearPhoneNumber">C</button>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!--  -->
            <div class="col-8 align-self-center">
              <div class="w-100 fnb-movie-ticket">
                <div class="row mx-0">
                  <div class="col-7 fnb-mt-cut py-2">
                    <div class="text-turncate mt-2 font-weight-bold h5">
                      {{ bookingDetails.movie_title }}
                    </div>
                    <div class="text-blue font-weight-bold">
                      {{ bookingDetails.lang_name }}
                      <span class="badge badge-primary ml-3">{{
                        bookingDetails.mf_name
                      }}</span>
                    </div>
                    <div class="mt-2">
                      <span>{{ bookingDetails.og_show_date | getDay }}</span>
                      <span>|</span>
                      <span
                        >{{ bookingDetails.og_show_date | getDayDigit }}
                        {{ bookingDetails.og_show_date | getMonth }}</span
                      >
                      <span>|</span>
                      <span>{{ bookingDetails.ss_start_show_time }}</span>
                    </div>
                    <div class="text-blue font-weight-bold mt-2">
                      Screen {{ bookingDetails.screen_name }}
                    </div>
                    <div>{{ bookingDetails.seats }}</div>
                  </div>
                  <div class="col-5 border-left-dashed py-2">
                    <div class="col-12 px-0">
                      <div class="row">
                        <div class="col-12">
                          <div
                            class="mt-2 font-weight-bold d-table border-bottom font-italic"
                          >
                            MOVIE
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-8">
                          <!-- {{ bookingDetails.movie_title }} -->
                          Net Amount
                        </div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(bookingDetails.sb_total_net_amount)
                          }}
                        </div>
                      </div>

                      <div
                        class="row"
                        v-for="(charges, chargesIndex) in AdditionalCharges"
                        :key="chargesIndex"
                      >
                        <div class="col-8">{{ charges.ct_name }}</div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            charges.pas_is_rebate &&
                            charges.pas_is_rebate === "Y"
                              ? -currFormat(charges.sp_value)
                              : currFormat(charges.sp_value)
                          }}
                        </div>
                      </div>

                      <div
                        class="row"
                        v-if="bookingDetails.total_add_ons_charge"
                      >
                        <div class="col-8">
                          {{ $t("addon_amount") }}
                        </div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(bookingDetails.total_add_ons_charge)
                          }}
                        </div>
                      </div>

                      <div class="price-Border"></div>

                      <div class="row">
                        <div class="col-8 fw-500">
                          <!-- {{ bookingDetails.movie_title }} -->
                          Box Office Total
                        </div>
                        <div class="col-4 text-right fw-500">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(bookingDetails.sb_total_amount)
                          }}
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <div
                            class="mt-2 font-weight-bold d-table border-bottom font-italic"
                          >
                            F&B
                          </div>
                        </div>
                      </div>

                      <div
                        class="row"
                        v-for="(item, itemIndex) in Items"
                        :key="itemIndex"
                      >
                        <div class="col-8">
                          {{ item.item_name }} &nbsp;* &nbsp;{{ item.quantity }}
                          <span
                            v-if="
                              item.hasOwnProperty('final_combo_array') &&
                                item.final_combo_array.length > 0
                            "
                            class="fs-12"
                            ><br />({{
                              item.final_combo_array
                                .map((x) => x.quantity + "x- " + x.item_name)
                                .join(", ")
                            }})</span
                          >
                        </div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(item.fp_amount * item.quantity)
                          }}
                        </div>
                      </div>

                      <div
                        class="row"
                        v-for="(Tax, TaxIndex) in Taxes"
                        :key="TaxIndex + Tax.ct_name"
                      >
                        <div class="col-8">{{ Tax.ct_name }}</div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(Tax.totalTax)
                          }}
                        </div>
                      </div>

                      <div v-if="FnBItemsTotalPrice" class="price-Border"></div>

                      <div class="row" v-if="FnBItemsTotalPrice">
                        <div class="col-8 fw-500">
                          <!-- {{ bookingDetails.movie_title }} -->
                          F&B Total
                        </div>
                        <div class="col-4 text-right fw-500">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(FnBItemsTotalPrice)
                          }}
                        </div>
                      </div>

                      <div v-if="selectedAddons.length > 0" class="row">
                        <div class="col-12">
                          <div
                            class="mt-2 font-weight-bold d-table border-bottom font-italic"
                          >
                            Add-Ons
                          </div>
                        </div>
                      </div>

                      <div
                        class="row"
                        v-for="(addOn, addOnIndex) in selectedAddons"
                        :key="addOnIndex"
                      >
                        <!-- {{item.fp_total_amount * item.quantity}} -->
                        <div class="col-8">
                          {{ addOn.add_on_item_name }} &nbsp;* &nbsp;{{
                            addOn.quantity
                          }}
                        </div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(addOn.add_on_item_price * addOn.quantity)
                          }}
                        </div>
                      </div>

                      <!-- EXTRA ADDON CHARGES -->

                      <div
                        class="row"
                        v-for="(Tax, TaxIndex) in addonsAdditionalCharges"
                        :key="TaxIndex + Tax.ct_name"
                      >
                        <div class="col-8">{{ Tax.ct_name }}</div>
                        <div class="col-4 text-right">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(Tax.totalTax)
                          }}
                        </div>
                      </div>

                      <div
                        v-if="selectedAddons.length > 0"
                        class="price-Border"
                      ></div>

                      <div class="row" v-if="selectedAddons.length > 0">
                        <div class="col-8 fw-500">
                          Add-Ons Total
                        </div>
                        <div class="col-4 text-right fw-500">
                          {{ Currency | uppercase }}&nbsp;{{
                            currFormat(selectedAddonsTotalPrice)
                          }}
                        </div>
                      </div>

                      <div class="mt-1"></div>

                      <div class="row text-success">
                        <div class="col-8 fw-500">
                          Discount
                        </div>
                        <div class="col-4 text-right fw-500">
                          - {{ Currency | uppercase }}&nbsp;{{
                            currFormat(offerPrice)
                          }}
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-8">
                          <h6 class="my-2 font-weight-bold">Total</h6>
                        </div>
                        <div class="col-4 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ Currency | uppercase }}&nbsp;{{
                              (parseFloat(bookingDetails.sb_total_amount) +
                                selectedAddonsTotalPrice +
                                FnBItemsTotalPrice -
                                offerPrice)
                                | RoundOff
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- did the same as posFnBFinalTicket -->
            <div class="col-4 text-center mt-3">
              <button
                :disabled="!showSendSmsSection"
                v-on:click="onSendSMS()"
                class="btn-blue-lg mr-1"
                :class="!showSendSmsSection ? 'disbled-section' : ''"
              >
                Send SMS
              </button>
            </div>
            <div class="col-8 text-center mt-3">
              <button
                v-if="isReprint"
                @click="GetEjsTicket(true)"
                class="btn-blue-lg"
                >Reprint</button
              >
              <button
                v-if="!isReprint"
                @click="GetEjsTicket()"
                class="btn-blue-lg"
                >Print</button
              >
              <button
                v-if="ShowPrintReceipt == 'Y'"
                @click="PrintReceipt()"
                class="btn-blue-lg"
              >
                Print Receipt
              </button>
              <button
                v-if="
                  printTimCardHolderReceipt &&
                    USE_TIM_INTEGRATION == 'Y' &&
                    PRINT_TIM_CARD_RECEIPT_POS == 'Y'
                "
                @click="printCreditCardReceiptTim()"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Card Receipt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="" class="d-none" ref="print_boxoffice_fnb_ticket">
      <div v-html="EjsData"></div>
    </div>

    <BO-sales-receipt ref="SalesReceipt"></BO-sales-receipt>

    <Bo-Fnb-sales-receipt
      ref="boxofficefnb_SalesReceipt"
      :itemsList="itemsList"
      :taxes="taxes"
      :taxesTotal="taxesTotal"
      :currency="currency"
    ></Bo-Fnb-sales-receipt>

    <Ticket-Product-sales-receipt
      ref="ticketsprodcuts_SalesReceipt"
      :itemsList="itemsList"
      :taxes="taxes"
      :taxesTotal="taxesTotal"
      :currency="currency"
    ></Ticket-Product-sales-receipt>

    <ChangeUserLocationPopUp :onCancelUserLocationPopUp="callClose" />
    <ManagerAuthLogin
      :moduleName="'pticket_print'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_pticket_print'"
    />
    <div
      id="cardReceiptTim"
      ref="cardReceiptTim"
      style="width: 100%; text-align: center;"
      class="d-none"
    >
      <pre style="white-space: pre-wrap" v-text="TIM_CARDHOLDER_RECEIPT"></pre>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { authenticationService } from "@/services/AuthenticationService";
import Printd from "printd";
import moment from "moment";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import PosFnbService from "@/services/PosFnbService";
import SReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/sales_receipts";
import BOFnbSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/bo&fnb_sales_receipt";
import TPSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/Tickets_Products_sales_receipt";
import ChangeUserLocationPopUp from "@/components/Partials/ChangeUserLocationPopUp";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { BASEURL } from "@/config/index";

import { EventBus } from "@/main";

export default {
  components: {
    "BO-sales-receipt": SReceipt,
    "Bo-Fnb-sales-receipt": BOFnbSReceipt,
    "Ticket-Product-sales-receipt": TPSReceipt,
    ChangeUserLocationPopUp,
    ManagerAuthLogin,
  },
  data() {
    return {
      overallPrice: 0,
      addOnsArr: [],
      noAuth: false,
      currentDate: "",
      phoneError: null,
      phonenumber: null,
      TemplateList: [],
      EjsData: null,
      SelectedCountryCode: "",
      Countries: [],
      CodeListCopy: [],
      searchCode: "",
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
      isReprint: false,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
      ],
    };
  },
  props: {
    onClickHandler: {
      type: Function,
    },
    onBackHandler: { type: Function },
    onClickCloseButton: { type: Function },
    itemsList: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
    subTotal: {
      type: Number,
      default: null,
    },
    taxes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    taxesTotal: {
      type: Number,
      default: null,
    },
  },
  mounted() {},
  watch: {
    bookingDetails(newVal) {
      console.log("newVal TEST bookingDetails", newVal);
      if (newVal && this.DirectPrint == "Y") {
        this.GetEjsTicket();
      }
    },
  },
  computed: {
    printTimCardHolderReceipt() {
      console.log(
        "this.$store.getters.TIM_CARDHOLDER_RECEIPT",
        this.$store.getters.TIM_CARDHOLDER_RECEIPT
      );
      return this.$store.getters.TIM_CARDHOLDER_RECEIPT;
    },
    pos_final_page_standBy_time() {
      console.log(
        "parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)",
        parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME)
      );
      return parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME);
    },
    DirectPrint() {
      return this.$store.getters.DirectPrint;
    },
    ShowPrintReceipt() {
      return this.$store.getters.showPrintReceiptBtn;
    },
    showSendSmsSection() {
      if (
        this.$store.getters.ShowSendSMSSection &&
        this.$store.getters.ShowSendSMSSection == "N"
      ) {
        return false;
      } else {
        return true;
      }
    },
    input_number: {
      get() {
        return this.$store.getters.customer_mobile_number;
      },
      set(value) {
        this.$store.dispatch("updateCustomerMobileNumber", value);
      },
    },
    getCustMobCode() {
      return this.$store.getters.getCustMobCode;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    addonsAdditionalCharges() {
      return this.$store.getters.addonsAdditionalCharges;
    },
    selectedAddonsTotalPrice() {
      return this.$store.getters.selectedAddonsTotalPrice;
    },
    selectedAddons() {
      return this.$store.getters.selectedAddons;
    },

    getTaxAmount() {
      let TaxValue = null;
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach((e) => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.$store.getters.getOfferPrice
        ? parseFloat(this.$store.getters.getOfferPrice).toFixed(2)
        : 0;
    },
    fnbtotalvalue() {
      return this.$store.getters.FnBTotalValue;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    Items() {
      return this.itemsList;
    },
    Currency() {
      return this.currency;
    },
    SubTotal() {
      return this.subTotal ? this.subTotal : null;
    },
    Total() {
      return this.subTotal !== null && this.taxesTotal !== null
        ? this.subTotal + this.taxesTotal
        : null;
    },
    Taxes() {
      return this.taxes;
    },
    getTotalFnBTax() {
      let taxes = null;

      if (this.Taxess && this.Taxes.length > 0) {
        this.Taxes.forEach((e) => {
          taxes += e.totalTax;
        });
        return taxes;
      } else {
        return (taxes = 0.0);
      }
    },
    FnbNetAmount() {
      let fnbamount = null;

      if (this.Items && this.Items.length > 0) {
        this.Items.forEach((e) => {
          fnbamount += e.fp_amount;
        });
        return fnbamount;
      } else {
        return (fnbamount = 0.0);
      }
    },
    TaxesTotal() {
      return this.taxesTotal ? this.taxesTotal : null;
    },
    totalAmount() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    ...mapGetters([
      "TOTAL_AMOUNT",
      "isBoxofficeflag",
      "IDforBoxOfficeEjs",
      "IDforFnBEjs",
      "MANAGER_AUTH_FOR_REPRINT",
      "TIM_CARDHOLDER_RECEIPT",
      "USE_TIM_INTEGRATION",
      "PRINT_TIM_CARD_RECEIPT_POS",
    ]),
    ...mapState({
      FnBItemsTotalPrice: (state) =>
        state.FnBStore.selectedFnBItemsTotalPrice +
        state.FnBStore.totalAdditionalTaxes,
    }),
  },
  beforeMount() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    this.name = this.secureStore.get("USINFO").first_name;

    const { cinema_id } = this.secureStore.get("USINFO");
    this.SelectedCountryCode = this.getCustMobCode;
    this.getCinemaTicketTemplate(cinema_id);
    this.getCountriesList();
  },
  methods: {
    sleep(n) {
      return new Promise((resolve) => setTimeout(resolve, n));
    },
    async printBO() {
      this.$socket.emit("on_print_ticket", {
        baseurl: BASEURL,
        ttype: "",
        showBookingId: this.IDforBoxOfficeEjs.sb_id,
        cinema_id: this.IDforBoxOfficeEjs.cinema_id,
        isReprint: this.isReprint,
      });
      return await this.sleep(300);
    },
    async printBOAddon() {
      let addOnsArr = this.bookingDetails.final_addon_gross_charges.filter(
        (add_on) => {
          return add_on.is_additional_price_on_ticket === "N";
        }
      );
      let arabic_company_name = JSON.parse(
        this.bookingDetails.translation_data
      ).filter((lang) => {
        return lang.langaugeId == 3;
      })[0].company_name;
      let overallPrice = 0;
      this.addOnsArr = [...addOnsArr];
      addOnsArr.map((z, index) => {
        overallPrice += z.final_price;
        this.$socket.emit("on_print_ticket", {
          addOns: JSON.stringify(z),
          bookingDetails: JSON.stringify({
            template_id: this.TemplateList[0].template_id,
            pos_user_name: this.bookingDetails.pos_user_name,
            translationData: arabic_company_name,
            cine_name: this.bookingDetails.cine_name,
            cine_address: this.bookingDetails.cine_address,
            company_name: this.bookingDetails.company_name,
            vat_number: this.bookingDetails.vat_number,
            sb_id: this.bookingDetails.sb_id,
            sb_booking_code: this.bookingDetails.sb_booking_code,
            og_show_date: this.bookingDetails.og_show_date,
            og_show_time: this.bookingDetails.og_show_time,
            sb_booking_date: this.bookingDetails.sb_booking_date_time,
            sb_booking_time: this.bookingDetails.sb_booking_date_time,
          }),
          ttype: "addon-ticket",
          isReprint: this.isReprint,
          baseurl: BASEURL,
        });
        this.overallPrice = overallPrice;
        // index * setTimeoutvalue);
      });

      return await this.sleep(600);
    },
    async printBOSecurity() {
      this.$socket.emit("on_print_ticket", {
        showBookingId: this.bookingDetails.sb_id,
        cinema_id: this.secureStore.get("USINFO").cinema_id,
        overallPrice: this.overallPrice,
        baseurl: BASEURL,
        ttype: "security-ticket",
        addOnsArr: JSON.stringify(this.addOnsArr),
        isReprint: this.isReprint,
      });
      return await this.sleep(1200);
    },
    async printFnB() {
      this.$socket.emit("on_print_ticket", {
        baseurl: BASEURL,
        ttype: "fnb",
        OrderCode: this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE.orderCode,
        Type: "Print",
        UserID: this.secureStore.get("USINFO").user_id,
        isReprint: this.isReprint,
      });
      return await this.sleep(1700);
    },
    async printFnBSecurity() {
      this.$socket.emit("on_print_ticket", {
        baseurl: BASEURL,
        ttype: "fnb-security",
        OrderCode: this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE.orderCode,
        UserID: this.secureStore.get("USINFO").user_id,
        cinemaId: this.secureStore.get("USINFO").cinema_id,
        isReprint: this.isReprint,
      });
      return await this.sleep(2000);
    },
    printCreditCardReceiptTim() {
      if (this.TIM_CARDHOLDER_RECEIPT) {
        this.$store.dispatch("onSetAndSendLog", {
          action: `Selected TIM Cardholder option`,
          page_name: "POS booking",
          api_name: window.location.hash,
        });
        const { cinema_id } = this.secureStore.get("USINFO");
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              this.$socket.emit("on_print_ticket", {
                ttype: "tim_card_holder_receipt",
                htmlData: document.getElementById("cardReceiptTim").outerHTML,
              });
            }
          } catch (err) {}
        } else {
          let loader = this.$loading.show();
          this.EjsData = this.TIM_CARDHOLDER_RECEIPT;
          this.$nextTick(() => {
            loader.hide();
            const p = new Printd();
            if (this.$refs.cardReceiptTim) {
              p.print(this.$refs.cardReceiptTim, []);
            }
          });
        }
      } else {
        this.$toasted.show("Card holder receipt not found");
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
    getCountriesList: function() {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error :", error);
        });
    },
    getCinemaTicketTemplate: function(cinema_id) {
      let body = {
        cine_id: cinema_id,
      };
      MasterService.TicketTemplateByCinemaID(body).then((response) => {
        const { data } = response;
        console.log("data ::::::::::", data);

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "pticket_print") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_pticket_print");
          this.GetEjsTicket();
        }
      }
    },
    GetEjsTicket: function(isReprint = false) {
      if (isReprint && !this.noAuth && this.MANAGER_AUTH_FOR_REPRINT == "Y") {
        this.$bvModal.show("authManager_pticket_print");
      } else {
        var userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              if (
                this.TemplateList.length > 0 &&
                (this.TemplateList[0].template_id == 28 ||
                  this.TemplateList[0].template_id == 30)
              ) {
                // if (this.bookingDetails.final_addon_gross_charges.length > 0) {
                //   console.log("in addons");
                //   this.printBO()
                //     .then(() => {
                //       console.log("in here at bo");
                //       return this.printBOAddon();
                //     })
                //     .then(() => {
                //       console.log("in here at bo security");
                //       return this.printBOSecurity();
                //     })
                //     .then(() => {
                //       console.log("in here at fnb");
                //       return this.printFnB();
                //     })
                //     .then(() => {
                //       console.log("in here at fnb security");
                //       return this.printFnBSecurity();
                //     });
                // } else {
                //   this.printBO()
                //     .then(() => {
                //       console.log("in here at bo security");
                //       return this.printBOSecurity();
                //     })
                //     .then(() => {
                //       console.log("in here at fnb");
                //       return this.printFnB();
                //     })
                //     .then(() => {
                //       console.log("in here at fnb security");
                //       return this.printFnBSecurity();
                //     });
                // }

                let addOnsArr = this.bookingDetails.final_addon_gross_charges.filter(
                  (add_on) => {
                    return add_on.is_additional_price_on_ticket === "N";
                  }
                );
                let arabic_company_name = JSON.parse(
                  this.bookingDetails.translation_data
                ).filter((lang) => {
                  return lang.langaugeId == 3;
                })[0].company_name;
                let overallPrice = 0;
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "",
                  showBookingId: this.IDforBoxOfficeEjs.sb_id,
                  cinema_id: this.IDforBoxOfficeEjs.cinema_id,
                  isReprint: this.isReprint,
                });

                if (addOnsArr.length > 0) {
                  addOnsArr.map((z, index) => {
                    overallPrice += z.final_price;
                    setTimeout(() => {
                      this.$socket.emit("on_print_ticket", {
                        addOns: JSON.stringify(z),
                        bookingDetails: JSON.stringify({
                          template_id: this.TemplateList[0].template_id,
                          pos_user_name: this.bookingDetails.pos_user_name,
                          translationData: arabic_company_name,
                          cine_name: this.bookingDetails.cine_name,
                          cine_address: this.bookingDetails.cine_address,
                          company_name: this.bookingDetails.company_name,
                          vat_number: this.bookingDetails.vat_number,
                          sb_id: this.bookingDetails.sb_id,
                          sb_booking_code: this.bookingDetails.sb_booking_code,
                          og_show_date: this.bookingDetails.og_show_date,
                          og_show_time: this.bookingDetails.og_show_time,
                          sb_booking_date: this.bookingDetails
                            .sb_booking_date_time,
                          sb_booking_time: this.bookingDetails
                            .sb_booking_date_time,
                        }),
                        ttype: "addon-ticket",
                        isReprint: this.isReprint,
                        baseurl: BASEURL,
                      });
                    }, 2500);
                    // index * setTimeoutvalue);
                  });
                }
                setTimeout(
                  () => {
                    this.$socket.emit("on_print_ticket", {
                      showBookingId: this.bookingDetails.sb_id,
                      cinema_id,
                      overallPrice,
                      baseurl: BASEURL,
                      ttype: "security-ticket",
                      addOnsArr: JSON.stringify(addOnsArr),
                      isReprint: this.isReprint,
                    });
                  },
                  this.bookingDetails.final_addon_gross_charges.length > 0
                    ? 4000
                    : 3000
                );
                setTimeout(
                  () => {
                    this.$socket.emit("on_print_ticket", {
                      baseurl: BASEURL,
                      ttype: "fnb",
                      OrderCode: this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE
                        .orderCode,
                      Type: "Print",
                      UserID: this.secureStore.get("USINFO").user_id,
                      isReprint: this.isReprint,
                    });
                  },
                  this.bookingDetails.final_addon_gross_charges.length > 0
                    ? 5000
                    : 4000
                );
                setTimeout(
                  () => {
                    this.$socket.emit("on_print_ticket", {
                      baseurl: BASEURL,
                      ttype: "fnb-security",
                      OrderCode: this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE
                        .orderCode,
                      UserID: this.secureStore.get("USINFO").user_id,
                      cinemaId: this.secureStore.get("USINFO").cinema_id,
                      isReprint: this.isReprint,
                    });
                  },
                  this.bookingDetails.final_addon_gross_charges.length > 0
                    ? 6300
                    : 6000
                );
              } else {
                // console.log('data',this.$store.getters)
                //console.log("showBookingId", this.bookingDetails.sb_id)
                this.$socket.emit("on_print_ticket", {
                  baseurl: BASEURL,
                  ttype: "boxfnb",
                  sb_id: this.IDforBoxOfficeEjs.sb_id,
                  ft_id: this.IDforFnBEjs.ft_id,
                  cinema_id: this.IDforBoxOfficeEjs.cinema_id,
                  flag: "BoxOfficeFnbTicket",
                  isReprint: this.isReprint,
                });
              }
            }
          } catch (err) {}
        } else if (
          this.TemplateList.length > 0 &&
          (this.TemplateList[0].template_id == 28 ||
            this.TemplateList[0].template_id == 30)
        ) {
          let loader = this.$loading.show();
          console.log("this.IDforBoxOfficeEjs", this.IDforBoxOfficeEjs);

          PosService.GetTicketEjs(
            this.IDforBoxOfficeEjs.sb_id,
            this.IDforBoxOfficeEjs.cinema_id,
            this.isReprint
          )
            .then((response) => {
              const { data } = response;
              this.EjsData = data;

              this.$nextTick(() => {
                this.goToRoute();
              });
            })
            .then(() => {
              // console.log(
              //   this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE,
              //   "this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE"
              // );
              if (this.Items && this.Items.length > 0) {
                let payload = {
                  OrderCode: this.$store.getters.GETFNB_BOXOFFICE_ORDER_CODE
                    .orderCode,
                  Type: "Print",
                  UserID: this.secureStore.get("USINFO").user_id,
                  isReprint: !this.isReprint,
                };
                PosFnbService.GetFnbOrderEjs(payload).then((response) => {
                  const { data } = response;
                  this.EjsData = data;

                  this.$nextTick(() => {
                    this.goToRoute();
                  });
                });
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        } else {
          let loader = this.$loading.show();
          PosService.GetBoxOffice_FnbTicketEjs(
            this.IDforBoxOfficeEjs.sb_id,
            this.IDforFnBEjs.ft_id || 0,
            this.IDforBoxOfficeEjs.cinema_id,
            "BoxOfficeFnbTicket",
            this.isReprint
          )
            .then((response) => {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                this.goToRoute();
              });
            })
            .then(() => {
              PosService.GetFnbOrderEjs({});
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
        this.isReprint = true;
      }
    },
    _GetEjsTicket: function(isReprint = false) {
      if (isReprint && !this.noAuth && this.MANAGER_AUTH_FOR_REPRINT == "Y") {
        this.$bvModal.show("authManager_pticket_print");
      } else {
        var userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              // console.log('data',this.$store.getters)
              //console.log("showBookingId", this.bookingDetails.sb_id)
              this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "boxfnb",
                sb_id: this.IDforBoxOfficeEjs.sb_id,
                ft_id: this.IDforFnBEjs.ft_id,
                cinema_id: this.IDforBoxOfficeEjs.cinema_id,
                flag: "BoxOfficeFnbTicket",
                isReprint: this.isReprint,
              });
            }
          } catch (err) {}
        } else {
          let loader = this.$loading.show();

          PosService.GetBoxOffice_FnbTicketEjs(
            this.IDforBoxOfficeEjs.sb_id,
            this.IDforFnBEjs.ft_id || 0,
            this.IDforBoxOfficeEjs.cinema_id,
            "BoxOfficeFnbTicket",
            this.isReprint
          )
            .then((response) => {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                this.goToRoute();
              });
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
        this.isReprint = true;
      }
    },
    goToRoute: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Print ticket option selected.`,
        page_name: "box office fnb final ticket",
        api_name: window.location.hash,
      });
      const p = new Printd();
      p.print(this.$refs.print_boxoffice_fnb_ticket, []);
    },
    PrintReceipt: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Print reciept option selected.`,
        page_name: "box office fnb final ticket",
        api_name: window.location.hash,
      });
      const p = new Printd();

      if (this.TemplateList && this.TemplateList.length > 0) {
        if (this.TemplateList[0].receipt_temp_id == 1) {
          EventBus.$emit("printSalesReceipt");
        } else if (this.TemplateList[0].receipt_temp_id == 2) {
          EventBus.$emit("printBO&FnbReceipt");
        } else if (this.TemplateList[0].receipt_temp_id == 3) {
          EventBus.$emit("printTPReceipt");
        } else {
          EventBus.$emit("printTPReceipt");
        }
      } else {
        this.$toasted.show("Please select a default receipt template");
      }
    },
    checkDifferentUserLocation() {
      let default_token = authenticationService.get("DFLT_USINFO");
      let logged_token = authenticationService.get("USINFO");

      if (
        default_token &&
        logged_token &&
        default_token.hasOwnProperty("user_id") &&
        logged_token.hasOwnProperty("user_id")
      ) {
        if (default_token.user_id == logged_token.user_id) {
          return true;
        } else {
          this.$bvModal.show("userLocationPopup");
          return false;
        }
      } else {
        return true;
      }
    },
    callClose: function(check = true) {
      let checkCount = 0;

      if (check) {
        if (!this.checkDifferentUserLocation()) {
          checkCount++;
        } else {
          checkCount = 0;
        }
      }

      if (checkCount == 0) {
        try {
          if (this.$socket) {
            this.$socket.emit("home_page");
          }
        } catch (err) {}
        this.onClickHandler("Refresh");
        this.$store.dispatch("onCloseClearIDsforBoxOffice");
        this.$store.dispatch("onCloseClearIDsforFnb");
        this.$store.dispatch("ResetCustomizationData");
        this.$store.dispatch("onResetOffersStoreState");
        this.$store.dispatch("clearAllInput");
        this.$store.dispatch("resetCashCardData");
        this.$store.dispatch("ResetCardTrxDetails");
        this.$store.dispatch("onResetEmployeeDetails");
        this.$store.dispatch("onResetDateStoreState");
        this.$store.dispatch("ResetAddonData");
        this.$store.dispatch("MAKE_DATA_EMPTY");
        this.$store.dispatch("onResetFnBStoreState");
        //   this.onClickHandler('PosPackageFinalTicket');
        this.onClickCloseButton();
      }
    },
    clearPhoneNumber: function() {
      this.phonenumber = null;
      this.input_number = "";
    },
    _onSliceNUmber: function() {
      this.phonenumber = this.phonenumber.slice(0, -1);
      if (this.phonenumber.length == 0) {
        this.phonenumber = null;
      }
    },
    onSliceNUmber: function() {
      this.$store.dispatch("sliceNumber");
    },
    _onClickNumber: function(num) {
      this.phonenumber
        ? (this.phonenumber += `${num}`)
        : (this.phonenumber = `${num}`);
    },
    onClickNumber: function(index) {
      this.input_number += this.phone_value[index].name;
    },
    inputChange(event) {},
    onSendSMS() {
      console.log("this.input_number", this.input_number);
      console.log("this.SelectedCountryCode", this.getCustMobCode);
      if (this.input_number.length > 0 && this.getCustMobCode.length > 0) {
        this.$store.dispatch("sendSms", { source: "ticket" });
      } else {
        this.$toasted.show(
          "Please enter mobile number and select country code"
        );
      }
    },
    phonenumberHandler: function(event, input) {
      let phoneReg = /\d{7,12}/;
      if (!this.phonenumber) {
        this.$toasted.show("Please enter mobile number");
        // this.phoneError = "Please Enter Phone Number.";
      } else if (this.phonenumber && !phoneReg.test(this.phonenumber)) {
        this.phoneError =
          "Phone number must be digits and minimum 7 digits allows.";
      } else {
        this.$store.dispatch("onSetAndSendLog", {
          action: `SMS option selected for ticket at number : ${this.phonenumber}`,
          page_name: "POS booking",
          api_name: window.location.hash,
        });
        this.$store.dispatch("sendSms", { source: "ticket" });

        // this.onNumberSubmit({ phonenumber: this.phonenumber });
      }
      this.phoneError && this.phoneError.length > 0
        ? setTimeout(() => {
            this.phoneError = null;
          }, 1500)
        : "";
    },
  },
};
</script>

<style>
.pos-fnb-final-ticket-wrapper {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  height: calc(100vh);
  background-color: #fff;
}

.pos-fnb-final-ticket-wrapper .btn-modal-close {
  top: -12px;
  right: 12px;
  position: absolute;
}

.fnb-movie-ticket {
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px #808080ad;
}

.fnb-movie-table {
  width: 100%;
}

.fnb-mt-cut::before,
.fnb-mt-cut::after {
  content: "";
  width: 25px;
  right: -13px;
  z-index: 22;
  height: 25px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
}

.fnb-mt-cut::before {
  top: -13px;
  border-bottom: 2px solid grey;
}

.fnb-mt-cut::after {
  bottom: -13px;
  border-top: 2px solid grey;
}

.fnb-movie-table td:nth-child(2) {
  width: 60px;
  text-align: right;
}

/* .ticket-section {
  text-align: center;
  height: calc(100% - 52.913385826px);
  padding: 8px;
}
.ticket-wrapper {
  width: 302.36220472px;
  height: 100%;
  border: 1px solid #000000;
} */
td {
  padding: 0px;
}
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.price-Border {
  border-top: 1px dotted lightgray;
  margin: 5px;
}

.fw-500 {
  font-weight: 500;
}

.h-600 {
  height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posPackageFinalTicket.vue